import { SITE } from "@/constants/testIds";

const versions = [
  {
    n: "01",
    title: "An American Gratitude",
    desc: "A song of thanks that belongs to every American — across faiths, generations, and stories of arrival.",
  },
  {
    n: "02",
    title: "A Shabbat Blessing",
    desc: "A voice shaped by Friday-night light — blessing, memory, and the quiet weight of Shabbat.",
  },
  {
    n: "03",
    title: "Many Voices, One Candle",
    desc: "Artists and communities joining in ensemble — many traditions, one flame carried forward.",
  },
];

export const Versions = () => {
  return (
    <section
      id="versions"
      data-testid={SITE.versionsSection}
      className="py-24 sm:py-32 bg-background"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.32em] text-primary/90 mb-5">
            The Vision
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl text-foreground leading-tight tracking-tight text-balance">
            Three voices.
            <br />
            <span className="italic text-primary">One candle.</span>
          </h2>
          <div className="gold-rule w-24 mt-8" />
          <p className="mt-8 text-foreground/70 text-base sm:text-lg leading-relaxed max-w-2xl">
            Shabbat Shalom, America is imagined in three movements — three ways
            the same flame can be carried, depending on who is singing and who
            is listening.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-border/40 border border-border/40">
          {versions.map((v) => (
            <div
              key={v.n}
              className="group relative bg-background/80 p-10 sm:p-12 transition-colors duration-500 hover:bg-card/60"
            >
              <span className="font-serif text-primary text-sm tracking-[0.28em]">
                {v.n}
              </span>
              <h3 className="font-serif text-2xl sm:text-3xl text-foreground mt-6 leading-tight">
                {v.title}
              </h3>
              <p className="text-foreground/65 text-sm sm:text-base leading-relaxed mt-5">
                {v.desc}
              </p>
              <div className="mt-8 h-px w-10 bg-primary/60 group-hover:w-20 transition-all duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
